export default __webpack_public_path__ + "static/media/Biosphere_verde.153f1346.png";